import {TemplateWithPrimary} from '@dms/shared';

// Every prefill path has to land on the same template, so they all resolve it here.
export const getPrimaryDefaultTemplateId = (
  defaultTemplates: Pick<TemplateWithPrimary, 'id' | 'isPrimary'>[]
) =>
  defaultTemplates.find((template) => template.isPrimary)?.id ??
  // Without a primary, only one candidate is unambiguous; picking from several would be API order.
  (defaultTemplates.length === 1 ? defaultTemplates[0]?.id : undefined);
